import { createContext } from "react";

/**
 * `true` for every element rendered inside `ConfirmDialog.tsx` — the one
 * place `Button`'s destructive variant may render (DESIGN.md: "the red
 * button appears only inside a confirmation dialog"). Lives in its own
 * file, not inside `Button.tsx` or `ConfirmDialog.tsx`, so both can import
 * it without one importing the other (`Button` is a leaf `ConfirmDialog`
 * itself renders).
 *
 * A source-text scan (`frontend/tests/architecture/
 * destructive-button-guard.test.ts`) catches the common case — a literal
 * `variant="destructive"` written outside `ConfirmDialog.tsx` — cheaply,
 * at test time. It cannot catch a value computed at runtime (a spread
 * prop, a ternary, a variable holding the string "destructive"): four
 * such shapes were planted in review and every one sailed past the
 * regex with zero violations reported. This context backs a *runtime*
 * check in `Button.tsx` instead, which inspects the actual value the
 * component is asked to render with, at the actual render site — closing
 * every way of computing that value, not just the syntax the scanner's
 * author already knew to look for.
 */
export const ConfirmDialogContext = createContext(false);
